import React from 'react'
import { Accordion, AccordionButton, AccordionIcon, AccordionItem, AccordionPanel, Box } from '@chakra-ui/react'
import { ChevronRightIcon } from '@chakra-ui/icons'
import WorkExperiencProject from './WorkExperiencProject'
import NotAvailable from '../NotAvailable'

const WorkExperienceTitle = ({ workExp }) => {
    return (
        <Accordion defaultIndex={[0]} allowMultiple pb="4">
            <AccordionItem>
                <AccordionButton>
                    <Box as="span" flex='1' textAlign='left' fontSize="sm">
                        {workExp['OrgName']} <ChevronRightIcon mx="2" />   {workExp['JobTitle']} <ChevronRightIcon mx="2" /> {workExp['TimeLine']}
                    </Box>
                    <AccordionIcon />
                </AccordionButton>
                <AccordionPanel pb={4}>
                    {
                        workExp.Projects.length === 0 ? <NotAvailable /> :
                            workExp.Projects.map((project, index) => <WorkExperiencProject key={index} project={project} />)
                    }
                </AccordionPanel>
            </AccordionItem>
        </Accordion>
    )
}

export default WorkExperienceTitle